module.exports = __webpack_public_path__ + "img/icon_menu-o.b93e8b73.png";